const enum ColumnTypes {
  STRING = 'String',
  DATE = 'Date',
  DATE_ONLY = 'DateOnly',
  NUMBER = 'Number'
}

export { ColumnTypes };
